import React, { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

const UseDropDown = (url) => {
    const [data, setData] = useState([]);

    async function getData() {
        if (!url) return;
        axiosInstance.get(url).then(res => {
            const rawData = Array.isArray(res.data)
                ? res.data
                : (Array.isArray(res.data?.data) ? res.data.data : []);

            const tempData = rawData.map((item) => {
                const label = item.name || (item.bankName ? (item.accountNumber ? `${item.bankName} - ${item.accountNumber}` : item.bankName) : (item.label || item.title || item.code || String(item.id || "")));
                return {
                    ...item,
                    value: item.id !== undefined ? item.id : item.value,
                    label: label || item.name || String(item.id || "")
                };
            });
            setData(tempData);
        }).catch(err => {
            console.log(err, "err");
        });
    }

    useEffect(() => {
        getData();
    }, [url]);

    return { data, getData };
};

export default UseDropDown;